import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SafeHtmlPipe } from '../../../shared/validators/safe-html.pipe';
import { ICONS } from '../../../utils/svg-icons';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';

@Component({
  selector: 'app-search-popup',
  imports: [CommonModule, FormsModule, SafeHtmlPipe],
  templateUrl: './search-popup.component.html',
  styleUrl: './search-popup.component.scss',
  providers: [NgbActiveModal], // ✅ Add provider here
})
export class SearchPopupComponent {
  searchContent: any;
  ICONS = ICONS;
  // @Output() closeEvent = new EventEmitter<void>();
  // @ViewChild('offcanvasElement', { static: false }) offcanvasElement!: ElementRef; // Use non-static ViewChild
  constructor(
    // private renderer: Renderer2,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _commonDataService: CommonDataSharingService,
    private _toastr: ToastrService,
    public activeOffcanvas: NgbActiveOffcanvas,
  ) {
    if (this._activatedRoute.snapshot.paramMap.get('id')) {
      this.searchContent = this._activatedRoute.snapshot.paramMap.get('id');
    }
  }

  onSearch() {
    if (this.searchContent.trim() === '' || this.searchContent.trim().length < 3) {
      this._toastr.warning('Please enter atleast 3 characters to search');
      return;
    }
    this._commonDataService.setSearchQuery(this.searchContent); // Set the search query in the service
    this._router.navigate(['/search']);
    this.searchContent = '';

    this.activeOffcanvas.close();
    // this.handleCloseEvent();
  }
  // handleCloseEvent(): void {
  //   const offcanvasEl = document.querySelector('.offcanvas.offcanvas-top') as HTMLElement;
  //   if (offcanvasEl) {
  //     this.renderer.removeClass(offcanvasEl, 'show');
  //     this.renderer.addClass(offcanvasEl, 'hide');
  //     this.renderer.removeStyle(offcanvasEl, 'overflow');
  //     this.renderer.removeStyle(offcanvasEl, 'padding-right');
  //   }
  //   this.renderer.removeClass(document.body, 'offcanvas-open');
  //   this.renderer.removeStyle(document.body, 'overflow');
  //   this.renderer.removeStyle(document.body, 'padding-right');
  //   this.closeEvent.emit();
  // }
  onClose() {
    // this._activeModal.close();
    this.activeOffcanvas.close();
  }
}
